export class ApplianceVO {
    public planApplianceID: Number;
    public applianceID: Number;
    public applianceName: String;
    public quantity: Number = 0;
}
